// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1_eJh","header":"ReportDetails_header__OuVLF","title":"ReportDetails_title__2D7Rh","left":"ReportDetails_left__YL4qP"};